import { DB_APPLICATION_STATUS } from '#client/constants/application';

export const APPLICATION_RECEIVED = {
  // if the user bought the EIN in the post-purchase during the bank application and waiting ein:
  BOUGHT_EIN_IN_PRE: {
    TITLE: 'We got your application!',
    DESCRIPTION: 'When you’re officially formed, log in to ZenBusiness to start banking.',
    EIN_BOX: {
      TITLE: 'Next steps',
      DESCRIPTIONS: [
        {
          title: 'We’ll finish your formation and get your EIN',
          description:
            'Track it in the Formation Tracker in our app, or on your dashboard. We’ll take care of adding your EIN.'
        },
        {
          title: 'We’ll submit your application',
          description:
            'We’ll update the info for your business (name, EIN, etc.) to finalize your bank account and submit for approval.'
        },
        {
          title: 'Access banking by logging in to ZenBusiness',
          description:
            'When you’re official, you’ll log in to your dashboard with your ZenBusiness credentials to start banking.'
        }
      ]
    },
    CTA_TEXT: 'Go to my dashboard',
    REDIRECT: false
  },

  // If the user bought or said they’d provide their EIN
  WILL_BUY_EIN: {
    TITLE: 'We got your application!',
    DESCRIPTION: 'Now we’re just waiting for your business to get officially formed.',
    EIN_BOX: {
      TITLE: 'Here’s how to get your EIN',
      DESCRIPTIONS: [
        {
          title: 'Answer a few more questions for your EIN',
          description:
            'We’ll get you through the EIN questions as fast and easy as possible for the IRS application.'
        },
        {
          title: 'We’ll submit your EIN app to the IRS',
          description:
            'When your formation’s complete, we’ll submit your EIN application to the IRS. You can keep tabs on your formation in the Formation Tracker in our app, or under “We’re on it” in your dashboard.'
        },
        {
          title: 'We’ll submit your EIN for your bank account',
          description:
            'When we get your EIN from the IRS, we’ll add it to your bank account application and submit it for approval.'
        }
      ]
    },
    CTA_TEXT: 'Next',
    REDIRECT: true
  },
  WAITING_EIN: {
    TITLE: 'We got your application!',
    DESCRIPTION: 'Now we’re just waiting for your business to get officially formed.',
    EIN_BOX: {
      TITLE: 'Next steps',
      DESCRIPTIONS: [
        {
          title: 'We’ll finish up your formation',
          description:
            'You can keep tabs on it in the Formation Tracker in our app, or under “We’re on it” in your dashboard.'
        },
        {
          title: 'Get your EIN from the IRS website',
          description:
            'When your formation is complete, you’ll need to get your EIN from the IRS. Contact us with any questions.'
        },
        {
          title: 'Give us your EIN',
          description: 'When you get your EIN, please enter it on your banking dashboard.'
        },
        {
          title: 'We’ll submit your application',
          description:
            'When we get your EIN, we’ll submit your bank account application for approval.'
        }
      ]
    },
    CTA_TEXT: 'Next',
    REDIRECT: true
  },
  WAITING_BANKING_ORDER_PROCESSES: {
    TITLE: 'We got your application!',
    DESCRIPTION: 'Now we’re just waiting for your business to get officially formed.',
    EIN_BOX: {
      TITLE: 'Our next steps',
      DESCRIPTIONS: [
        {
          title: 'We’ll finish up your formation',
          description:
            'You can keep tabs on it in the Formation Tracker in our app, or under “We’re on it” in your dashboard.'
        },
        {
          title: 'We’ll submit your application',
          description:
            'When your formation is complete, we’ll submit your bank account application for approval.'
        },
        {
          title: 'Access banking by logging in to ZenBusiness',
          description:
            'When you’re official, you’ll log in to your dashboard with your ZenBusiness credentials to start banking.'
        }
      ]
    },
    CTA_TEXT: 'Next',
    REDIRECT: true
  }
};

export const NOT_SUBMITTABLE_APPLICATION_STATUSES = [
  DB_APPLICATION_STATUS.PENDING,
  DB_APPLICATION_STATUS.AWAITING_DOCUMENTS,
  DB_APPLICATION_STATUS.PENDING_REVIEW,
  DB_APPLICATION_STATUS.APPROVED,
  DB_APPLICATION_STATUS.DENIED,
  DB_APPLICATION_STATUS.CANCELED,
  DB_APPLICATION_STATUS.EXPIRED,
  DB_APPLICATION_STATUS.CLOSED,
  DB_APPLICATION_STATUS.NOT_QUALIFIED
];
